import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { LoadingDots } from '../../ui';
import { logOut } from '../auth/authSlice';
import { useNavigate } from "react-router-dom";

const logoutMessages = [
  "Catch ya later—time to blast you back to the login screen!",
  "Whoops, your session's expired—sayonara, time to log out!",
  "We're kicking you out with love—back to the login lounge you go!",
  "Your VIP pass has expired—poof, you're logged out, superstar!",
  "Time's up! We're sending you to the logout dimension—zap!",
]

const Logout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // Select a random message from the logoutMessages array
  const randomMessage = logoutMessages[Math.floor(Math.random() * logoutMessages.length)];

  useEffect(() => {
    dispatch(logOut())
      .unwrap()
      .catch(() => {})
      .finally(() => {
        navigate('/login', { replace: true });
      });
  }, [dispatch, navigate]);

  return (
    <LoadingDots message={randomMessage} fullContainer={true}/>
  );
}

export default Logout;
